import axios from 'axios'
import { baseApiUrl } from '../config/config'

export const getSchedule = async (params) => {
  // console.log(params)
  try {
    const res = await axios.post(`${baseApiUrl}/schedule`, params)
    // console.log(res.data)
    return res.data
  } catch (err) {
    throw new Error(err.name)
    // return null
  }
}
